module.exports = __webpack_public_path__ + "static/media/conn-yellow.d5a67be4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icon/conn-yellow.svg
// module id = 417
// module chunks = 0